import React, { useState, useEffect, useRef } from "react";
import { Search, Bell, User, X, Edit2, Save, AlertTriangle, MessageSquare } from "lucide-react";
import "../style/Header.css";

const PLANTAS_DB = {
    papa: [
        {
            id: 1,
            nombre: "Papa Criolla",
            nombreCientifico: "Solanum tuberosum phureja",
            imagen: "https://images.unsplash.com/photo-1518977676601-b53f82aba655?w=400",
            temperatura: { min: 15, max: 20, optimo: 18 },
            humedad: { min: 60, max: 80, optimo: 70 },
            ph: { min: 5.5, max: 6.5, optimo: 6.0 },
            luz: "Media - 6-8 horas diarias",
            tiempoCrecimiento: "90-120 días",
            riego: "Regular, evitar encharcamiento",
            fertilizacion: "Rica en potasio y fósforo",
            plagas: ["Gusano blanco", "Polilla de la papa", "Tizón tardío"],
            cosecha: "Cuando el follaje se torna amarillo",
            almacenamiento: "Lugar fresco, seco y oscuro (4-10°C)",
            nutrientes: "Rica en carbohidratos, vitamina C y potasio",
            densidadSiembra: "25-30 cm entre plantas, 80-90 cm entre surcos",
            profundidadSiembra: "10-15 cm",
            tips: [
                "Realizar aporque 2-3 veces durante el ciclo",
                "Rotar cultivo cada 3-4 años",
                "Usar semilla certificada"
            ]
        },
        {
            id: 2,
            nombre: "Papa Pastusa",
            nombreCientifico: "Solanum tuberosum",
            imagen: "https://images.unsplash.com/photo-1596910547037-846b1980329f?w=400",
            temperatura: { min: 13, max: 18, optimo: 16 },
            humedad: { min: 65, max: 85, optimo: 75 },
            ph: { min: 5.8, max: 6.8, optimo: 6.3 },
            luz: "Media - 6-8 horas diarias",
            tiempoCrecimiento: "150-180 días",
            riego: "Moderado y constante",
            fertilizacion: "NPK 10-20-20 en fase inicial",
            plagas: ["Tizón tardío", "Trips", "Gusano blanco"],
            cosecha: "4-6 meses después de siembra",
            almacenamiento: "8-10°C, humedad 85-90%",
            nutrientes: "Alto contenido de almidón",
            densidadSiembra: "30-35 cm entre plantas",
            profundidadSiembra: "10-12 cm",
            tips: [
                "Ideal para climas fríos",
                "Excelente para consumo industrial",
                "Resistente al transporte"
            ]
        }
    ],
    tomate: [
        {
            id: 3,
            nombre: "Tomate Chonto",
            nombreCientifico: "Solanum lycopersicum",
            imagen: "https://images.unsplash.com/photo-1592924357228-91a4daadcfea?w=400",
            temperatura: { min: 18, max: 28, optimo: 24 },
            humedad: { min: 60, max: 80, optimo: 70 },
            ph: { min: 6.0, max: 6.8, optimo: 6.5 },
            luz: "Alta - 8-10 horas diarias",
            tiempoCrecimiento: "90-120 días",
            riego: "Frecuente pero moderado",
            fertilizacion: "Alto en potasio durante fructificación",
            plagas: ["Mosca blanca", "Minador", "Tizón tardío"],
            cosecha: "Cuando alcanza color rojo uniforme",
            almacenamiento: "Temperatura ambiente, no refrigerar",
            nutrientes: "Rico en licopeno, vitamina C y A",
            densidadSiembra: "40-50 cm entre plantas",
            profundidadSiembra: "1-2 cm",
            tips: [
                "Requiere tutorado",
                "Eliminar chupones regularmente",
                "Buena ventilación previene enfermedades"
            ]
        },
        {
            id: 4,
            nombre: "Tomate Cherry",
            nombreCientifico: "Solanum lycopersicum var. cerasiforme",
            imagen: "https://images.unsplash.com/photo-1587411768941-fc3a9861e8d7?w=400",
            temperatura: { min: 20, max: 30, optimo: 25 },
            humedad: { min: 50, max: 70, optimo: 60 },
            ph: { min: 6.0, max: 7.0, optimo: 6.5 },
            luz: "Muy alta - 10-12 horas diarias",
            tiempoCrecimiento: "60-80 días",
            riego: "Regular, evitar estrés hídrico",
            fertilizacion: "NPK balanceado 15-15-15",
            plagas: ["Araña roja", "Pulgones", "Mosca blanca"],
            cosecha: "En racimos cuando estén rojos",
            almacenamiento: "Temperatura ambiente 18-20°C",
            nutrientes: "Alto contenido de antioxidantes",
            densidadSiembra: "30-40 cm entre plantas",
            profundidadSiembra: "0.5-1 cm",
            tips: [
                "Excelente para cultivo en macetas",
                "Muy productivo",
                "Requiere menos espacio"
            ]
        }
    ],
    lechuga: [
        {
            id: 5,
            nombre: "Lechuga Crespa",
            nombreCientifico: "Lactuca sativa",
            imagen: "https://images.unsplash.com/photo-1622206151226-18ca2c9ab4a1?w=400",
            temperatura: { min: 15, max: 20, optimo: 18 },
            humedad: { min: 60, max: 80, optimo: 70 },
            ph: { min: 6.0, max: 7.0, optimo: 6.5 },
            luz: "Media - 6-8 horas diarias",
            tiempoCrecimiento: "45-60 días",
            riego: "Frecuente y ligero",
            fertilizacion: "Rico en nitrógeno",
            plagas: ["Pulgones", "Trips", "Caracoles"],
            cosecha: "Antes de floración",
            almacenamiento: "Refrigeración 0-2°C",
            nutrientes: "Rica en fibra, vitaminas A y K",
            densidadSiembra: "25-30 cm entre plantas",
            profundidadSiembra: "0.5-1 cm",
            tips: [
                "Sembrar en horas frescas",
                "Evitar temperaturas altas",
                "Cosechar en la mañana"
            ]
        }
    ],
    zanahoria: [
        {
            id: 6,
            nombre: "Zanahoria Nantes",
            nombreCientifico: "Daucus carota",
            imagen: "https://images.unsplash.com/photo-1598170845058-32b9d6a5da37?w=400",
            temperatura: { min: 16, max: 22, optimo: 19 },
            humedad: { min: 60, max: 75, optimo: 68 },
            ph: { min: 6.0, max: 7.0, optimo: 6.5 },
            luz: "Alta - 8-10 horas diarias",
            tiempoCrecimiento: "70-90 días",
            riego: "Constante, suelo siempre húmedo",
            fertilizacion: "Bajo en nitrógeno, alto en potasio",
            plagas: ["Mosca de la zanahoria", "Pulgones", "Nematodos"],
            cosecha: "Cuando alcance tamaño deseado",
            almacenamiento: "Refrigeración 0-2°C, 95% humedad",
            nutrientes: "Rica en betacaroteno y vitamina A",
            densidadSiembra: "5-8 cm entre plantas",
            profundidadSiembra: "1-2 cm",
            tips: [
                "Requiere suelo suelto y profundo",
                "Ralear para mejor desarrollo",
                "Evitar suelos pesados"
            ]
        }
    ],
    maíz: [
        {
            id: 7,
            nombre: "Maíz Amarillo",
            nombreCientifico: "Zea mays",
            imagen: "https://images.unsplash.com/photo-1551754655-cd27e38d2076?w=400",
            temperatura: { min: 18, max: 30, optimo: 24 },
            humedad: { min: 50, max: 70, optimo: 60 },
            ph: { min: 5.5, max: 7.5, optimo: 6.5 },
            luz: "Muy alta - 10-14 horas diarias",
            tiempoCrecimiento: "90-120 días",
            riego: "Abundante durante floración",
            fertilizacion: "Alto en nitrógeno y fósforo",
            plagas: ["Gusano cogollero", "Barrenador", "Trips"],
            cosecha: "Cuando granos estén duros",
            almacenamiento: "Secar hasta 12-14% humedad",
            nutrientes: "Rico en carbohidratos y fibra",
            densidadSiembra: "20-25 cm entre plantas, 70-80 cm entre surcos",
            profundidadSiembra: "3-5 cm",
            tips: [
                "Sembrar en bloques para polinización",
                "Requiere aporque",
                "Proteger de vientos fuertes"
            ]
        }
    ],
    fresa: [
        {
            id: 8,
            nombre: "Fresa Albion",
            nombreCientifico: "Fragaria × ananassa",
            imagen: "https://images.unsplash.com/photo-1518635017498-87f514b751ba?w=400",
            temperatura: { min: 15, max: 25, optimo: 20 },
            humedad: { min: 60, max: 80, optimo: 70 },
            ph: { min: 5.5, max: 6.5, optimo: 6.0 },
            luz: "Alta - 8-10 horas diarias",
            tiempoCrecimiento: "90-120 días primera cosecha",
            riego: "Goteo, mantener humedad constante",
            fertilizacion: "Balanceado, rico en potasio",
            plagas: ["Araña roja", "Botrytis", "Pulgones"],
            cosecha: "Cuando 75% esté rojo",
            almacenamiento: "Refrigeración 0-2°C inmediata",
            nutrientes: "Rica en vitamina C y antioxidantes",
            densidadSiembra: "25-30 cm entre plantas",
            profundidadSiembra: "Corona a nivel del suelo",
            tips: [
                "Usar acolchado plástico",
                "Renovar plantación cada 2-3 años",
                "Eliminar estolones regularmente"
            ]
        }
    ]
};

const Header = () => {
    const [usuario, setUsuario] = useState(null);
    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const [showNotifications, setShowNotifications] = useState(false);
    const [showSearchResults, setShowSearchResults] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [selectedPlanta, setSelectedPlanta] = useState(null);
    const [editingProfile, setEditingProfile] = useState(false);
    const [alertas, setAlertas] = useState([]);
    const [mensajesRecientes, setMensajesRecientes] = useState([]);
    const [profileData, setProfileData] = useState({
        nombre: "",
        apellido: "",
        email: ""
    });

    const profileRef = useRef(null);
    const notificationRef = useRef(null);
    const searchRef = useRef(null);


    useEffect(() => {
        const fetchUserData = async () => {
            const token = localStorage.getItem("token");
            if (!token) return;

            try {
                const response = await fetch("https://agro-nexus-prod.vercel.app/api/perfil", {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                const data = await response.json();
                if (data.success) {
                    setUsuario(data.usuario);
                    setProfileData({
                        nombre: data.usuario.nombre,
                        apellido: data.usuario.apellido,
                        email: data.usuario.email
                    });
                }
            } catch (error) {
                console.error("Error al cargar perfil:", error);
            }
        };

        fetchUserData();
    }, []);


    useEffect(() => {
        const fetchNotifications = async () => {
            const token = localStorage.getItem("token");
            if (!token) return;

            try {

                const alertasRes = await fetch("https://agro-nexus-prod.vercel.app/api/alertas", {
                    headers: { Authorization: `Bearer ${token}` }
                });
                const alertasData = await alertasRes.json();
                if (alertasData.success) {
                    setAlertas(alertasData.alertas.slice(0, 3));
                }


                const chatsRes = await fetch("https://agro-nexus-prod.vercel.app/api/chats", {
                    headers: { Authorization: `Bearer ${token}` }
                });
                const chatsData = await chatsRes.json();
                if (chatsData.chats) {
                    const mensajes = [];
                    for (const chat of chatsData.chats.slice(0, 3)) {
                        const mensajesRes = await fetch(
                            `https://agro-nexus-prod.vercel.app/api/chats/${chat.id}/mensajes`,
                            { headers: { Authorization: `Bearer ${token}` } }
                        );
                        const mensajesData = await mensajesRes.json();
                        if (mensajesData.mensajes && mensajesData.mensajes.length > 0) {
                            const ultimoMensaje = mensajesData.mensajes[mensajesData.mensajes.length - 1];
                            mensajes.push({
                                ...ultimoMensaje,
                                chat_nombre: chat.nombre || `Chat ${chat.id}`
                            });
                        }
                    }
                    setMensajesRecientes(mensajes);
                }
            } catch (error) {
                console.error("Error al cargar notificaciones:", error);
            }
        };

        fetchNotifications();
        const interval = setInterval(fetchNotifications, 30000);
        return () => clearInterval(interval);
    }, []);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (profileRef.current && !profileRef.current.contains(event.target)) {
                setShowProfileMenu(false);
            }
            if (notificationRef.current && !notificationRef.current.contains(event.target)) {
                setShowNotifications(false);
            }
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setShowSearchResults(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleSearch = (query) => {
        setSearchQuery(query);

        if (query.trim().length < 2) {
            setSearchResults([]);
            setShowSearchResults(false);
            return;
        }

        const queryLower = query.toLowerCase().trim();
        const results = [];

        Object.entries(PLANTAS_DB).forEach(([categoria, plantas]) => {
            plantas.forEach((planta) => {
                if (
                    planta.nombre.toLowerCase().includes(queryLower) ||
                    planta.nombreCientifico.toLowerCase().includes(queryLower) ||
                    categoria.includes(queryLower)
                ) {
                    results.push({ ...planta, categoria });
                }
            });
        });

        setSearchResults(results);
        setShowSearchResults(results.length > 0);
    };

    const handleSaveProfile = async () => {
        const token = localStorage.getItem("token");
        if (!token) return;

        try {
            const response = await fetch("https://agro-nexus-prod.vercel.app/api/perfil", {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify(profileData)
            });

            if (response.ok) {
                setUsuario({ ...usuario, ...profileData });
                setEditingProfile(false);
                alert("Perfil actualizado correctamente");
            }
        } catch (error) {
            console.error("Error al actualizar perfil:", error);
            alert("Error al actualizar perfil");
        }
    };

    return (
        <>
            <header className="dashboard-header">
                <div className="header-left">
                    <img src="/img/logo.png" alt="AgroNexus" className="header-logo" />
                    <span className="header-title">AgroNexus</span>
                </div>

                {/* Barra de búsqueda */}
                <div className="search-bar" ref={searchRef} style={{ position: "relative" }}>
                    <Search className="icon" />
                    <input
                        type="text"
                        placeholder="Buscar plantas, verduras, frutas..."
                        value={searchQuery}
                        onChange={(e) => handleSearch(e.target.value)}
                        onFocus={() => searchResults.length > 0 && setShowSearchResults(true)}
                    />

                    {/* Resultados de búsqueda */}
                    {showSearchResults && (
                        <div style={styles.searchResultsContainer}>
                            <div style={styles.searchResultsHeader}>
                                <span style={styles.resultsCount}>{searchResults.length} resultados</span>
                                <button onClick={() => setShowSearchResults(false)} style={styles.closeBtn}>
                                    <X size={16} />
                                </button>
                            </div>
                            <div style={styles.searchResults}>
                                {searchResults.map((planta) => (
                                    <div
                                        key={planta.id}
                                        style={styles.searchResultItem}
                                        onClick={() => {
                                            setSelectedPlanta(planta);
                                            setShowSearchResults(false);
                                        }}
                                    >
                                        <img src={planta.imagen} alt={planta.nombre} style={styles.resultImage} />
                                        <div style={styles.resultInfo}>
                                            <div style={styles.resultName}>{planta.nombre}</div>
                                            <div style={styles.resultScientific}>{planta.nombreCientifico}</div>
                                            <div style={styles.resultCategory}>
                                                {planta.categoria.charAt(0).toUpperCase() + planta.categoria.slice(1)}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                {/* Acciones del header */}
                <div className="header-actions">
                    {/* Notificaciones */}
                    <div style={{ position: "relative" }} ref={notificationRef}>
                        <Bell
                            className="icon"
                            onClick={() => setShowNotifications(!showNotifications)}
                            style={{ cursor: "pointer" }}
                        />
                        {(alertas.length > 0 || mensajesRecientes.length > 0) && (
                            <span style={styles.badge}>
                                {alertas.length + mensajesRecientes.length}
                            </span>
                        )}

                        {showNotifications && (
                            <div style={styles.notificationsPanel}>
                                <div style={styles.notificationsHeader}>
                                    <h3 style={styles.panelTitle}>Notificaciones</h3>
                                    <button onClick={() => setShowNotifications(false)} style={styles.closeBtn}>
                                        <X size={16} />
                                    </button>
                                </div>

                                <div style={styles.notificationsContent}>
                                    {alertas.length > 0 && (
                                        <div style={styles.notificationSection}>
                                            <div style={styles.sectionTitle}>
                                                <AlertTriangle size={16} style={{ color: "#f59e0b" }} />
                                                <span>Alertas de Sensores</span>
                                            </div>
                                            {alertas.map((alerta) => (
                                                <div key={alerta.id} style={styles.notificationItem}>
                                                    <div style={styles.notificationText}>
                                                        <strong>{alerta.sensor_nombre}</strong> - {alerta.terreno_nombre}
                                                    </div>
                                                    <div style={styles.notificationDetail}>
                                                        {alerta.tipo}: {alerta.valor}
                                                        {alerta.valor_minimo && ` (Min: ${alerta.valor_minimo})`}
                                                        {alerta.valor_maximo && ` (Max: ${alerta.valor_maximo})`}
                                                    </div>
                                                    <div style={styles.notificationTime}>
                                                        {new Date(alerta.fecha).toLocaleString()}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {mensajesRecientes.length > 0 && (
                                        <div style={styles.notificationSection}>
                                            <div style={styles.sectionTitle}>
                                                <MessageSquare size={16} style={{ color: "#3b82f6" }} />
                                                <span>Mensajes Recientes</span>
                                            </div>
                                            {mensajesRecientes.map((mensaje) => (
                                                <div key={mensaje.id} style={styles.notificationItem}>
                                                    <div style={styles.notificationText}>
                                                        <strong>{mensaje.remitente_nombre}</strong> en {mensaje.chat_nombre}
                                                    </div>
                                                    <div style={styles.notificationDetail}>
                                                        {mensaje.contenido.substring(0, 50)}
                                                        {mensaje.contenido.length > 50 && "..."}
                                                    </div>
                                                    <div style={styles.notificationTime}>
                                                        {new Date(mensaje.fecha_envio).toLocaleString()}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {alertas.length === 0 && mensajesRecientes.length === 0 && (
                                        <div style={styles.emptyNotifications}>
                                            No hay notificaciones nuevas
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Perfil de usuario */}
                    <div style={{ position: "relative" }} ref={profileRef}>
                        <User
                            className="icon"
                            onClick={() => setShowProfileMenu(!showProfileMenu)}
                            style={{ cursor: "pointer" }}
                        />

                        {showProfileMenu && (
                            <div style={styles.profilePanel}>
                                <div style={styles.profileHeader}>
                                    <h3 style={styles.panelTitle}>Mi Perfil</h3>
                                    <button onClick={() => setShowProfileMenu(false)} style={styles.closeBtn}>
                                        <X size={16} />
                                    </button>
                                </div>

                                <div style={styles.profileContent}>
                                    {!editingProfile ? (
                                        <>
                                            <div style={styles.profileInfo}>
                                                <div style={styles.profileAvatar}>
                                                    {usuario?.nombre?.charAt(0)}{usuario?.apellido?.charAt(0)}
                                                </div>
                                                <div style={styles.profileDetails}>
                                                    <div style={styles.profileName}>
                                                        {usuario?.nombre} {usuario?.apellido}
                                                    </div>
                                                    <div style={styles.profileEmail}>{usuario?.email}</div>
                                                </div>
                                            </div>
                                            <button
                                                onClick={() => setEditingProfile(true)}
                                                style={styles.editButton}
                                            >
                                                <Edit2 size={16} />
                                                <span>Editar Perfil</span>
                                            </button>
                                            <button
                                                onClick={() => {
                                                    localStorage.removeItem("token");
                                                    window.location.href = "/login";
                                                }}
                                                style={styles.logoutButton}
                                            >
                                                Cerrar Sesión
                                            </button>
                                        </>
                                    ) : (
                                        <div style={styles.editForm}>
                                            <div style={styles.formGroup}>
                                                <label style={styles.label}>Nombre</label>
                                                <input
                                                    type="text"
                                                    value={profileData.nombre}
                                                    onChange={(e) =>
                                                        setProfileData({ ...profileData, nombre: e.target.value })
                                                    }
                                                    style={styles.input}
                                                />
                                            </div>
                                            <div style={styles.formGroup}>
                                                <label style={styles.label}>Apellido</label>
                                                <input
                                                    type="text"
                                                    value={profileData.apellido}
                                                    onChange={(e) =>
                                                        setProfileData({ ...profileData, apellido: e.target.value })
                                                    }
                                                    style={styles.input}
                                                />
                                            </div>
                                            <div style={styles.formGroup}>
                                                <label style={styles.label}>Email</label>
                                                <input
                                                    type="email"
                                                    value={profileData.email}
                                                    onChange={(e) =>
                                                        setProfileData({ ...profileData, email: e.target.value })
                                                    }
                                                    style={styles.input}
                                                />
                                            </div>
                                            <div style={styles.editActions}>
                                                <button onClick={handleSaveProfile} style={styles.saveButton}>
                                                    <Save size={16} />
                                                    <span>Guardar</span>
                                                </button>
                                                <button
                                                    onClick={() => {
                                                        setEditingProfile(false);
                                                        setProfileData({
                                                            nombre: usuario.nombre,
                                                            apellido: usuario.apellido,
                                                            email: usuario.email
                                                        });
                                                    }}
                                                    style={styles.cancelButton}
                                                >
                                                    Cancelar
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </header>

            {/* Modal de información de planta */}
            {selectedPlanta && (
                <div style={styles.modal} onClick={() => setSelectedPlanta(null)}>
                    <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                        <button
                            onClick={() => setSelectedPlanta(null)}
                            style={styles.modalCloseBtn}
                        >
                            <X size={24} />
                        </button>

                        <div style={styles.plantaHeader}>
                            <img
                                src={selectedPlanta.imagen}
                                alt={selectedPlanta.nombre}
                                style={styles.plantaImage}
                            />
                            <div style={styles.plantaHeaderInfo}>
                                <h2 style={styles.plantaNombre}>{selectedPlanta.nombre}</h2>
                                <p style={styles.plantaCientifico}>{selectedPlanta.nombreCientifico}</p>
                                <span style={styles.plantaCategoria}>
                                    {selectedPlanta.categoria.charAt(0).toUpperCase() +
                                        selectedPlanta.categoria.slice(1)}
                                </span>
                            </div>
                        </div>

                        <div style={styles.plantaBody}>
                            {/* Condiciones Óptimas */}
                            <div style={styles.infoSection}>
                                <h3 style={styles.sectionTitleModal}>🌡️ Condiciones Óptimas</h3>
                                <div style={styles.conditionsGrid}>
                                    <div style={styles.conditionCard}>
                                        <div style={styles.conditionLabel}>Temperatura</div>
                                        <div style={styles.conditionValue}>
                                            {selectedPlanta.temperatura.optimo}°C
                                        </div>
                                        <div style={styles.conditionRange}>
                                            Rango: {selectedPlanta.temperatura.min}°C -{" "}
                                            {selectedPlanta.temperatura.max}°C
                                        </div>
                                    </div>
                                    <div style={styles.conditionCard}>
                                        <div style={styles.conditionLabel}>Humedad</div>
                                        <div style={styles.conditionValue}>
                                            {selectedPlanta.humedad.optimo}%
                                        </div>
                                        <div style={styles.conditionRange}>
                                            Rango: {selectedPlanta.humedad.min}% - {selectedPlanta.humedad.max}%
                                        </div>
                                    </div>
                                    <div style={styles.conditionCard}>
                                        <div style={styles.conditionLabel}>pH del Suelo</div>
                                        <div style={styles.conditionValue}>{selectedPlanta.ph.optimo}</div>
                                        <div style={styles.conditionRange}>
                                            Rango: {selectedPlanta.ph.min} - {selectedPlanta.ph.max}
                                        </div>
                                    </div>
                                    <div style={styles.conditionCard}>
                                        <div style={styles.conditionLabel}>Luz Solar</div>
                                        <div style={styles.conditionValueSmall}>{selectedPlanta.luz}</div>
                                    </div>
                                </div>
                            </div>

                            {/* Información de Cultivo */}
                            <div style={styles.infoSection}>
                                <h3 style={styles.sectionTitleModal}>🌱 Información de Cultivo</h3>
                                <div style={styles.infoGrid}>
                                    <div style={styles.infoItem}>
                                        <strong>⏱️ Tiempo de crecimiento:</strong> {selectedPlanta.tiempoCrecimiento}
                                    </div>
                                    <div style={styles.infoItem}>
                                        <strong>💧 Riego:</strong> {selectedPlanta.riego}
                                    </div>
                                    <div style={styles.infoItem}>
                                        <strong>🌿 Fertilización:</strong> {selectedPlanta.fertilizacion}
                                    </div>
                                    <div style={styles.infoItem}>
                                        <strong>📏 Densidad de siembra:</strong> {selectedPlanta.densidadSiembra}
                                    </div>
                                    <div style={styles.infoItem}>
                                        <strong>📐 Profundidad:</strong> {selectedPlanta.profundidadSiembra}
                                    </div>
                                </div>
                            </div>

                            {/* Plagas y Enfermedades */}
                            <div style={styles.infoSection}>
                                <h3 style={styles.sectionTitleModal}>🐛 Plagas y Enfermedades Comunes</h3>
                                <div style={styles.plagasList}>
                                    {selectedPlanta.plagas.map((plaga, index) => (
                                        <span key={index} style={styles.plagaTag}>
                                            {plaga}
                                        </span>
                                    ))}
                                </div>
                            </div>

                            {/* Cosecha y Almacenamiento */}
                            <div style={styles.infoSection}>
                                <h3 style={styles.sectionTitleModal}>🌾 Cosecha y Almacenamiento</h3>
                                <div style={styles.infoGrid}>
                                    <div style={styles.infoItem}>
                                        <strong>✂️ Momento de cosecha:</strong> {selectedPlanta.cosecha}
                                    </div>
                                    <div style={styles.infoItem}>
                                        <strong>📦 Almacenamiento:</strong> {selectedPlanta.almacenamiento}
                                    </div>
                                    <div style={styles.infoItem}>
                                        <strong>🥗 Valor nutricional:</strong> {selectedPlanta.nutrientes}
                                    </div>
                                </div>
                            </div>

                            {/* Tips y Recomendaciones */}
                            <div style={styles.infoSection}>
                                <h3 style={styles.sectionTitleModal}>💡 Tips y Recomendaciones</h3>
                                <ul style={styles.tipsList}>
                                    {selectedPlanta.tips.map((tip, index) => (
                                        <li key={index} style={styles.tipItem}>
                                            {tip}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

const styles = {
    badge: {
        position: "absolute",
        top: "-4px",
        right: "-4px",
        backgroundColor: "#ef4444",
        color: "white",
        borderRadius: "50%",
        width: "18px",
        height: "18px",
        fontSize: "0.7rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold"
    },
    searchResultsContainer: {
        position: "absolute",
        top: "calc(100% + 8px)",
        left: 0,
        right: 0,
        backgroundColor: "#23272f",
        borderRadius: "8px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
        maxHeight: "400px",
        overflow: "hidden",
        zIndex: 1000
    },
    searchResultsHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0.75rem 1rem",
        borderBottom: "1px solid #181c23"
    },
    resultsCount: {
        fontSize: "0.875rem",
        color: "#9ca3af"
    },
    closeBtn: {
        background: "none",
        border: "none",
        color: "#7fffd4",
        cursor: "pointer",
        padding: "0.25rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "4px",
        transition: "background-color 0.2s"
    },
    searchResults: {
        maxHeight: "350px",
        overflowY: "auto"
    },
    searchResultItem: {
        display: "flex",
        gap: "1rem",
        padding: "1rem",
        cursor: "pointer",
        transition: "background-color 0.2s",
        borderBottom: "1px solid #181c23"
    },
    resultImage: {
        width: "60px",
        height: "60px",
        objectFit: "cover",
        borderRadius: "8px",
        flexShrink: 0
    },
    resultInfo: {
        flex: 1
    },
    resultName: {
        fontSize: "1rem",
        fontWeight: "600",
        marginBottom: "0.25rem",
        color: "#e2e8f0"
    },
    resultScientific: {
        fontSize: "0.875rem",
        color: "#9ca3af",
        fontStyle: "italic",
        marginBottom: "0.25rem"
    },
    resultCategory: {
        fontSize: "0.75rem",
        color: "#7fffd4",
        backgroundColor: "#064e3b",
        padding: "0.25rem 0.5rem",
        borderRadius: "4px",
        display: "inline-block"
    },
    notificationsPanel: {
        position: "absolute",
        top: "calc(100% + 8px)",
        right: 0,
        width: "400px",
        backgroundColor: "#23272f",
        borderRadius: "8px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
        zIndex: 1000
    },
    notificationsHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "1rem",
        borderBottom: "1px solid #181c23"
    },
    panelTitle: {
        fontSize: "1.1rem",
        fontWeight: "600",
        margin: 0,
        color: "#e2e8f0"
    },
    notificationsContent: {
        maxHeight: "500px",
        overflowY: "auto"
    },
    notificationSection: {
        padding: "1rem",
        borderBottom: "1px solid #181c23"
    },
    sectionTitle: {
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
        fontSize: "0.875rem",
        fontWeight: "600",
        marginBottom: "0.75rem",
        color: "#d1d5db"
    },
    notificationItem: {
        padding: "0.75rem",
        backgroundColor: "#181c23",
        borderRadius: "6px",
        marginBottom: "0.5rem"
    },
    notificationText: {
        fontSize: "0.875rem",
        marginBottom: "0.25rem",
        color: "#e2e8f0"
    },
    notificationDetail: {
        fontSize: "0.8rem",
        color: "#9ca3af",
        marginBottom: "0.25rem"
    },
    notificationTime: {
        fontSize: "0.75rem",
        color: "#6b7280"
    },
    emptyNotifications: {
        padding: "2rem",
        textAlign: "center",
        color: "#9ca3af",
        fontSize: "0.875rem"
    },
    profilePanel: {
        position: "absolute",
        top: "calc(100% + 8px)",
        right: 0,
        width: "320px",
        backgroundColor: "#23272f",
        borderRadius: "8px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
        zIndex: 1000
    },
    profileHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "1rem",
        borderBottom: "1px solid #181c23"
    },
    profileContent: {
        padding: "1rem"
    },
    profileInfo: {
        display: "flex",
        gap: "1rem",
        marginBottom: "1rem"
    },
    profileAvatar: {
        width: "60px",
        height: "60px",
        borderRadius: "50%",
        backgroundColor: "#7fffd4",
        color: "#23272f",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "1.5rem",
        fontWeight: "bold",
        flexShrink: 0
    },
    profileDetails: {
        flex: 1
    },
    profileName: {
        fontSize: "1.1rem",
        fontWeight: "600",
        marginBottom: "0.25rem",
        color: "#e2e8f0"
    },
    profileEmail: {
        fontSize: "0.875rem",
        color: "#9ca3af"
    },
    editButton: {
        width: "100%",
        padding: "0.75rem",
        backgroundColor: "#7fffd4",
        color: "#23272f",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        fontSize: "0.875rem",
        fontWeight: "600",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.5rem",
        marginBottom: "0.5rem",
        transition: "background-color 0.2s"
    },
    logoutButton: {
        width: "100%",
        padding: "0.75rem",
        backgroundColor: "#181c23",
        color: "#e2e8f0",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        fontSize: "0.875rem",
        fontWeight: "500",
        transition: "background-color 0.2s"
    },
    editForm: {
        display: "flex",
        flexDirection: "column",
        gap: "1rem"
    },
    formGroup: {
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem"
    },
    label: {
        fontSize: "0.875rem",
        fontWeight: "500",
        color: "#d1d5db"
    },
    input: {
        padding: "0.75rem",
        backgroundColor: "#181c23",
        border: "1px solid #4b5563",
        borderRadius: "6px",
        color: "#e2e8f0",
        fontSize: "0.875rem",
        outline: "none"
    },
    editActions: {
        display: "flex",
        gap: "0.5rem"
    },
    saveButton: {
        flex: 1,
        padding: "0.75rem",
        backgroundColor: "#10b981",
        color: "white",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        fontSize: "0.875rem",
        fontWeight: "500",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.5rem",
        transition: "background-color 0.2s"
    },
    cancelButton: {
        flex: 1,
        padding: "0.75rem",
        backgroundColor: "#181c23",
        color: "#e2e8f0",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        fontSize: "0.875rem",
        fontWeight: "500",
        transition: "background-color 0.2s"
    },
    modal: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.85)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2000,
        padding: "2rem"
    },
    modalContent: {
        backgroundColor: "#23272f",
        borderRadius: "12px",
        maxWidth: "900px",
        width: "100%",
        maxHeight: "90vh",
        overflow: "auto",
        position: "relative",
        color: "#e2e8f0"
    },
    modalCloseBtn: {
        position: "absolute",
        top: "1rem",
        right: "1rem",
        background: "#181c23",
        border: "none",
        color: "#7fffd4",
        cursor: "pointer",
        padding: "0.5rem",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10,
        transition: "background-color 0.2s"
    },
    plantaHeader: {
        display: "flex",
        gap: "2rem",
        padding: "2rem",
        borderBottom: "1px solid #181c23"
    },
    plantaImage: {
        width: "200px",
        height: "200px",
        objectFit: "cover",
        borderRadius: "12px",
        flexShrink: 0
    },
    plantaHeaderInfo: {
        flex: 1
    },
    plantaNombre: {
        fontSize: "2rem",
        fontWeight: "bold",
        marginBottom: "0.5rem",
        color: "#e2e8f0"
    },
    plantaCientifico: {
        fontSize: "1.1rem",
        color: "#9ca3af",
        fontStyle: "italic",
        marginBottom: "1rem"
    },
    plantaCategoria: {
        display: "inline-block",
        padding: "0.5rem 1rem",
        backgroundColor: "#064e3b",
        color: "#7fffd4",
        borderRadius: "6px",
        fontSize: "0.875rem",
        fontWeight: "600"
    },
    plantaBody: {
        padding: "2rem"
    },
    infoSection: {
        marginBottom: "2rem"
    },
    sectionTitleModal: {
        fontSize: "1.3rem",
        fontWeight: "600",
        marginBottom: "1rem",
        color: "#e2e8f0"
    },
    conditionsGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
        gap: "1rem"
    },
    conditionCard: {
        backgroundColor: "#181c23",
        padding: "1.5rem",
        borderRadius: "8px",
        textAlign: "center"
    },
    conditionLabel: {
        fontSize: "0.875rem",
        color: "#9ca3af",
        marginBottom: "0.5rem"
    },
    conditionValue: {
        fontSize: "1.75rem",
        fontWeight: "bold",
        color: "#7fffd4",
        marginBottom: "0.25rem"
    },
    conditionValueSmall: {
        fontSize: "1rem",
        fontWeight: "bold",
        color: "#7fffd4",
        marginTop: "0.5rem"
    },
    conditionRange: {
        fontSize: "0.75rem",
        color: "#6b7280"
    },
    infoGrid: {
        display: "grid",
        gap: "0.75rem"
    },
    infoItem: {
        padding: "1rem",
        backgroundColor: "#181c23",
        borderRadius: "6px",
        fontSize: "0.95rem",
        lineHeight: "1.6",
        color: "#d1d5db"
    },
    plagasList: {
        display: "flex",
        flexWrap: "wrap",
        gap: "0.5rem"
    },
    plagaTag: {
        padding: "0.5rem 1rem",
        backgroundColor: "#7c2d12",
        color: "#f97316",
        borderRadius: "6px",
        fontSize: "0.875rem"
    },
    tipsList: {
        margin: 0,
        paddingLeft: "1.5rem"
    },
    tipItem: {
        marginBottom: "0.75rem",
        lineHeight: "1.6",
        fontSize: "0.95rem",
        color: "#d1d5db"
    }
};

export default Header;